export interface DialCountry {
  iso: string;
  name: string;
  dial: string;
}

export const DEFAULT_DIAL_ISO = "CO";

export const DIAL_COUNTRIES: DialCountry[] = [
  { iso: "AF", name: "Afganistán", dial: "93" },
  { iso: "AX", name: "Alandia", dial: "3" },
  { iso: "AL", name: "Albania", dial: "355" },
  { iso: "DE", name: "Alemania", dial: "49" },
  { iso: "AD", name: "Andorra", dial: "376" },
  { iso: "AO", name: "Angola", dial: "244" },
  { iso: "AI", name: "Anguilla", dial: "1" },
  { iso: "AG", name: "Antigua y Barbuda", dial: "1" },
  { iso: "SA", name: "Arabia Saudí", dial: "966" },
  { iso: "DZ", name: "Argelia", dial: "213" },
  { iso: "AR", name: "Argentina", dial: "54" },
  { iso: "AM", name: "Armenia", dial: "374" },
  { iso: "AW", name: "Aruba", dial: "297" },
  { iso: "AU", name: "Australia", dial: "61" },
  { iso: "AT", name: "Austria", dial: "43" },
  { iso: "AZ", name: "Azerbaiyán", dial: "994" },
  { iso: "BS", name: "Bahamas", dial: "1" },
  { iso: "BH", name: "Bahrein", dial: "973" },
  { iso: "BD", name: "Bangladesh", dial: "880" },
  { iso: "BB", name: "Barbados", dial: "1" },
  { iso: "BZ", name: "Belice", dial: "501" },
  { iso: "BJ", name: "Benín", dial: "229" },
  { iso: "BM", name: "Bermudas", dial: "1" },
  { iso: "BY", name: "Bielorrusia", dial: "375" },
  { iso: "BO", name: "Bolivia", dial: "591" },
  { iso: "BA", name: "Bosnia y Herzegovina", dial: "387" },
  { iso: "BW", name: "Botswana", dial: "267" },
  { iso: "BR", name: "Brasil", dial: "55" },
  { iso: "BN", name: "Brunei", dial: "673" },
  { iso: "BG", name: "Bulgaria", dial: "359" },
  { iso: "BF", name: "Burkina Faso", dial: "226" },
  { iso: "BI", name: "Burundi", dial: "257" },
  { iso: "BT", name: "Bután", dial: "975" },
  { iso: "BE", name: "Bélgica", dial: "32" },
  { iso: "CV", name: "Cabo Verde", dial: "238" },
  { iso: "KH", name: "Camboya", dial: "855" },
  { iso: "CM", name: "Camerún", dial: "237" },
  { iso: "CA", name: "Canadá", dial: "1" },
  { iso: "BQ", name: "Caribe Neerlandés", dial: "599" },
  { iso: "QA", name: "Catar", dial: "974" },
  { iso: "TD", name: "Chad", dial: "235" },
  { iso: "CZ", name: "Chequia", dial: "420" },
  { iso: "CL", name: "Chile", dial: "56" },
  { iso: "CN", name: "China", dial: "86" },
  { iso: "CY", name: "Chipre", dial: "357" },
  { iso: "VA", name: "Ciudad del Vaticano", dial: "3" },
  { iso: "CO", name: "Colombia", dial: "57" },
  { iso: "KM", name: "Comoras", dial: "269" },
  { iso: "CG", name: "Congo", dial: "242" },
  { iso: "CD", name: "Congo (Rep. Dem.)", dial: "243" },
  { iso: "KP", name: "Corea del Norte", dial: "850" },
  { iso: "KR", name: "Corea del Sur", dial: "82" },
  { iso: "CI", name: "Costa de Marfil", dial: "225" },
  { iso: "CR", name: "Costa Rica", dial: "506" },
  { iso: "HR", name: "Croacia", dial: "385" },
  { iso: "CU", name: "Cuba", dial: "53" },
  { iso: "CW", name: "Curazao", dial: "599" },
  { iso: "DK", name: "Dinamarca", dial: "45" },
  { iso: "DJ", name: "Djibouti", dial: "253" },
  { iso: "DM", name: "Dominica", dial: "1" },
  { iso: "EC", name: "Ecuador", dial: "593" },
  { iso: "EG", name: "Egipto", dial: "20" },
  { iso: "SV", name: "El Salvador", dial: "503" },
  { iso: "AE", name: "Emiratos Árabes Unidos", dial: "971" },
  { iso: "ER", name: "Eritrea", dial: "291" },
  { iso: "SK", name: "Eslovaquia", dial: "421" },
  { iso: "SI", name: "Eslovenia", dial: "386" },
  { iso: "ES", name: "España", dial: "34" },
  { iso: "US", name: "Estados Unidos", dial: "1" },
  { iso: "EE", name: "Estonia", dial: "372" },
  { iso: "SZ", name: "Esuatini", dial: "268" },
  { iso: "ET", name: "Etiopía", dial: "251" },
  { iso: "PH", name: "Filipinas", dial: "63" },
  { iso: "FI", name: "Finlandia", dial: "358" },
  { iso: "FJ", name: "Fiyi", dial: "679" },
  { iso: "FR", name: "Francia", dial: "33" },
  { iso: "GA", name: "Gabón", dial: "241" },
  { iso: "GM", name: "Gambia", dial: "220" },
  { iso: "GE", name: "Georgia", dial: "995" },
  { iso: "GH", name: "Ghana", dial: "233" },
  { iso: "GI", name: "Gibraltar", dial: "350" },
  { iso: "GR", name: "Grecia", dial: "30" },
  { iso: "GD", name: "Grenada", dial: "1" },
  { iso: "GL", name: "Groenlandia", dial: "299" },
  { iso: "GP", name: "Guadalupe", dial: "590" },
  { iso: "GU", name: "Guam", dial: "1" },
  { iso: "GT", name: "Guatemala", dial: "502" },
  { iso: "GF", name: "Guayana Francesa", dial: "594" },
  { iso: "GG", name: "Guernsey", dial: "44" },
  { iso: "GN", name: "Guinea", dial: "224" },
  { iso: "GQ", name: "Guinea Ecuatorial", dial: "240" },
  { iso: "GW", name: "Guinea-Bisáu", dial: "245" },
  { iso: "GY", name: "Guyana", dial: "592" },
  { iso: "HT", name: "Haití", dial: "509" },
  { iso: "HN", name: "Honduras", dial: "504" },
  { iso: "HK", name: "Hong Kong", dial: "852" },
  { iso: "HU", name: "Hungría", dial: "36" },
  { iso: "IN", name: "India", dial: "91" },
  { iso: "ID", name: "Indonesia", dial: "62" },
  { iso: "IQ", name: "Irak", dial: "964" },
  { iso: "IR", name: "Iran", dial: "98" },
  { iso: "IE", name: "Irlanda", dial: "353" },
  { iso: "BV", name: "Isla Bouvet", dial: "47" },
  { iso: "IM", name: "Isla de Man", dial: "44" },
  { iso: "CX", name: "Isla de Navidad", dial: "61" },
  { iso: "NF", name: "Isla de Norfolk", dial: "672" },
  { iso: "IS", name: "Islandia", dial: "354" },
  { iso: "KY", name: "Islas Caimán", dial: "1" },
  { iso: "CC", name: "Islas Cocos o Islas Keeling", dial: "61" },
  { iso: "CK", name: "Islas Cook", dial: "682" },
  { iso: "FO", name: "Islas Faroe", dial: "298" },
  { iso: "GS", name: "Islas Georgias del Sur y Sandwich del Sur", dial: "500" },
  { iso: "FK", name: "Islas Malvinas", dial: "500" },
  { iso: "MP", name: "Islas Marianas del Norte", dial: "1" },
  { iso: "MH", name: "Islas Marshall", dial: "692" },
  { iso: "PN", name: "Islas Pitcairn", dial: "64" },
  { iso: "SB", name: "Islas Salomón", dial: "677" },
  { iso: "SJ", name: "Islas Svalbard y Jan Mayen", dial: "4" },
  { iso: "TK", name: "Islas Tokelau", dial: "690" },
  { iso: "TC", name: "Islas Turks y Caicos", dial: "1" },
  { iso: "UM", name: "Islas Ultramarinas Menores de Estados Unidos", dial: "268" },
  { iso: "VI", name: "Islas Vírgenes de los Estados Unidos", dial: "1" },
  { iso: "VG", name: "Islas Vírgenes del Reino Unido", dial: "1" },
  { iso: "IL", name: "Israel", dial: "972" },
  { iso: "IT", name: "Italia", dial: "39" },
  { iso: "JM", name: "Jamaica", dial: "1" },
  { iso: "JP", name: "Japón", dial: "81" },
  { iso: "JE", name: "Jersey", dial: "44" },
  { iso: "JO", name: "Jordania", dial: "962" },
  { iso: "KZ", name: "Kazajistán", dial: "76" },
  { iso: "KE", name: "Kenia", dial: "254" },
  { iso: "KG", name: "Kirguizistán", dial: "996" },
  { iso: "KI", name: "Kiribati", dial: "686" },
  { iso: "XK", name: "Kosovo", dial: "383" },
  { iso: "KW", name: "Kuwait", dial: "965" },
  { iso: "LA", name: "Laos", dial: "856" },
  { iso: "LS", name: "Lesotho", dial: "266" },
  { iso: "LV", name: "Letonia", dial: "371" },
  { iso: "LR", name: "Liberia", dial: "231" },
  { iso: "LY", name: "Libia", dial: "218" },
  { iso: "LI", name: "Liechtenstein", dial: "423" },
  { iso: "LT", name: "Lituania", dial: "370" },
  { iso: "LU", name: "Luxemburgo", dial: "352" },
  { iso: "LB", name: "Líbano", dial: "961" },
  { iso: "MO", name: "Macao", dial: "853" },
  { iso: "MK", name: "Macedonia del Norte", dial: "389" },
  { iso: "MG", name: "Madagascar", dial: "261" },
  { iso: "MY", name: "Malasia", dial: "60" },
  { iso: "MW", name: "Malawi", dial: "265" },
  { iso: "MV", name: "Maldivas", dial: "960" },
  { iso: "ML", name: "Mali", dial: "223" },
  { iso: "MT", name: "Malta", dial: "356" },
  { iso: "MA", name: "Marruecos", dial: "212" },
  { iso: "MQ", name: "Martinica", dial: "596" },
  { iso: "MU", name: "Mauricio", dial: "230" },
  { iso: "MR", name: "Mauritania", dial: "222" },
  { iso: "YT", name: "Mayotte", dial: "262" },
  { iso: "FM", name: "Micronesia", dial: "691" },
  { iso: "MD", name: "Moldavia", dial: "373" },
  { iso: "MN", name: "Mongolia", dial: "976" },
  { iso: "ME", name: "Montenegro", dial: "382" },
  { iso: "MS", name: "Montserrat", dial: "1" },
  { iso: "MZ", name: "Mozambique", dial: "258" },
  { iso: "MM", name: "Myanmar", dial: "95" },
  { iso: "MX", name: "México", dial: "52" },
  { iso: "MC", name: "Mónaco", dial: "377" },
  { iso: "NA", name: "Namibia", dial: "264" },
  { iso: "NR", name: "Nauru", dial: "674" },
  { iso: "NP", name: "Nepal", dial: "977" },
  { iso: "NI", name: "Nicaragua", dial: "505" },
  { iso: "NG", name: "Nigeria", dial: "234" },
  { iso: "NU", name: "Niue", dial: "683" },
  { iso: "NO", name: "Noruega", dial: "47" },
  { iso: "NC", name: "Nueva Caledonia", dial: "687" },
  { iso: "NZ", name: "Nueva Zelanda", dial: "64" },
  { iso: "NE", name: "Níger", dial: "227" },
  { iso: "OM", name: "Omán", dial: "968" },
  { iso: "PK", name: "Pakistán", dial: "92" },
  { iso: "PW", name: "Palau", dial: "680" },
  { iso: "PS", name: "Palestina", dial: "970" },
  { iso: "PA", name: "Panamá", dial: "507" },
  { iso: "PG", name: "Papúa Nueva Guinea", dial: "675" },
  { iso: "PY", name: "Paraguay", dial: "595" },
  { iso: "NL", name: "Países Bajos", dial: "31" },
  { iso: "PE", name: "Perú", dial: "51" },
  { iso: "PF", name: "Polinesia Francesa", dial: "689" },
  { iso: "PL", name: "Polonia", dial: "48" },
  { iso: "PT", name: "Portugal", dial: "351" },
  { iso: "PR", name: "Puerto Rico", dial: "1" },
  { iso: "GB", name: "Reino Unido", dial: "44" },
  { iso: "CF", name: "República Centroafricana", dial: "236" },
  { iso: "DO", name: "República Dominicana", dial: "1" },
  { iso: "RE", name: "Reunión", dial: "262" },
  { iso: "RW", name: "Ruanda", dial: "250" },
  { iso: "RO", name: "Rumania", dial: "40" },
  { iso: "RU", name: "Rusia", dial: "73" },
  { iso: "EH", name: "Sahara Occidental", dial: "2" },
  { iso: "MF", name: "Saint Martin", dial: "590" },
  { iso: "WS", name: "Samoa", dial: "685" },
  { iso: "AS", name: "Samoa Americana", dial: "1" },
  { iso: "BL", name: "San Bartolomé", dial: "590" },
  { iso: "KN", name: "San Cristóbal y Nieves", dial: "1" },
  { iso: "SM", name: "San Marino", dial: "378" },
  { iso: "PM", name: "San Pedro y Miquelón", dial: "508" },
  { iso: "VC", name: "San Vicente y Granadinas", dial: "1" },
  { iso: "SH", name: "Santa Elena, Ascensión y Tristán de Acuña", dial: "290" },
  { iso: "LC", name: "Santa Lucía", dial: "1" },
  { iso: "ST", name: "Santo Tomé y Príncipe", dial: "239" },
  { iso: "SN", name: "Senegal", dial: "221" },
  { iso: "RS", name: "Serbia", dial: "381" },
  { iso: "SC", name: "Seychelles", dial: "248" },
  { iso: "SL", name: "Sierra Leone", dial: "232" },
  { iso: "SG", name: "Singapur", dial: "65" },
  { iso: "SX", name: "Sint Maarten", dial: "1" },
  { iso: "SY", name: "Siria", dial: "963" },
  { iso: "SO", name: "Somalia", dial: "252" },
  { iso: "LK", name: "Sri Lanka", dial: "94" },
  { iso: "ZA", name: "Sudáfrica", dial: "27" },
  { iso: "SD", name: "Sudán", dial: "249" },
  { iso: "SS", name: "Sudán del Sur", dial: "211" },
  { iso: "SE", name: "Suecia", dial: "46" },
  { iso: "CH", name: "Suiza", dial: "41" },
  { iso: "SR", name: "Surinam", dial: "597" },
  { iso: "TH", name: "Tailandia", dial: "66" },
  { iso: "TW", name: "Taiwán", dial: "886" },
  { iso: "TZ", name: "Tanzania", dial: "255" },
  { iso: "TJ", name: "Tayikistán", dial: "992" },
  { iso: "IO", name: "Territorio Británico del Océano Índico", dial: "246" },
  { iso: "TF", name: "Tierras Australes y Antárticas Francesas", dial: "262" },
  { iso: "TL", name: "Timor Oriental", dial: "670" },
  { iso: "TG", name: "Togo", dial: "228" },
  { iso: "TO", name: "Tonga", dial: "676" },
  { iso: "TT", name: "Trinidad y Tobago", dial: "1" },
  { iso: "TM", name: "Turkmenistán", dial: "993" },
  { iso: "TR", name: "Turquía", dial: "90" },
  { iso: "TV", name: "Tuvalu", dial: "688" },
  { iso: "TN", name: "Túnez", dial: "216" },
  { iso: "UA", name: "Ucrania", dial: "380" },
  { iso: "UG", name: "Uganda", dial: "256" },
  { iso: "UY", name: "Uruguay", dial: "598" },
  { iso: "UZ", name: "Uzbekistán", dial: "998" },
  { iso: "VU", name: "Vanuatu", dial: "678" },
  { iso: "VE", name: "Venezuela", dial: "58" },
  { iso: "VN", name: "Vietnam", dial: "84" },
  { iso: "WF", name: "Wallis y Futuna", dial: "681" },
  { iso: "YE", name: "Yemen", dial: "967" },
  { iso: "ZM", name: "Zambia", dial: "260" },
  { iso: "ZW", name: "Zimbabue", dial: "263" },
];

const dialByIso = new Map(DIAL_COUNTRIES.map((country) => [country.iso, country.dial]));

export function dialCodeForIso(iso: string | null | undefined): string {
  if (iso == null || iso === "") {
    return "";
  }
  return dialByIso.get(iso) ?? "";
}

export function dialChoiceLabel(country: DialCountry): string {
  return `${country.name} +${country.dial}`;
}

export const DIAL_CHOICES = DIAL_COUNTRIES.map((country) => ({
  id: country.iso,
  name: dialChoiceLabel(country),
}));

export function formatPhoneLine(phone: {
  number?: string | null;
  dial_code?: string | null;
  dial_iso?: string | null;
}): string {
  const number = (phone.number ?? "").trim();
  const dial = (phone.dial_code ?? "").replace(/\D/g, "") || dialCodeForIso(phone.dial_iso);
  if (number.length === 0) {
    return dial.length > 0 ? `+${dial}` : "";
  }
  const digits = number.replace(/\D/g, "");
  if (dial.length === 0 || digits.startsWith(dial)) {
    return number.startsWith("+") ? number : digits.length > 0 ? `+${digits}` : number;
  }
  return `+${dial} ${number}`;
}

